import React, { useEffect, useRef, useState, useCallback } from "react";
import styles from "./CrewSection.module.css";

const teamMembers = [
  { id: 1, name: "Hitesh Pitale", role: "Beverage Head", img: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/Hitesh%20Pitale%20-%20Beverage%20Head.jpg' },
  // { id: 2, name: "Monica Tipnis", role: "Guest Experience Manager", img: 'https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/Monica%20Tipnis%20-%20Guest%20Experience%20Manager.jpg' },
  { id: 3, name: "Rohit Vishnani", role: "Corporate Chef", img: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/Rohit%20Vishnani.jpeg" },
  { id: 4, name: "Tanka Joshi", role: "Operations Manager", img: "https://pub-9533a5728b7a4b43a9c2a556b5256245.r2.dev/Baglami-others/successStory/Tanka%20Joshi-%20operations%20manager.jpg" },
];

// Tripled array for infinite sliding
const extendedMembers = [...teamMembers, ...teamMembers, ...teamMembers];

const CrewSection = () => {
  const [index, setIndex] = useState(teamMembers.length);
  const [visibleSlides, setVisibleSlides] = useState(4);
  const intervalRef = useRef(null);
  const isTransitioning = useRef(false);

  // LOGIC CHECK: 4 or more triggers the carousel, less than 4 triggers static view
  const isCarousel = teamMembers.length >= 4;
  const displayMembers = isCarousel ? extendedMembers : teamMembers;

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 650) setVisibleSlides(1.2);
      else if (window.innerWidth < 950) setVisibleSlides(2);
      else if (window.innerWidth < 1250) setVisibleSlides(3);
      else setVisibleSlides(4);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleTransitionEnd = () => {
    if (!isCarousel) return;
    isTransitioning.current = false;
    if (index >= teamMembers.length * 2) {
      setIndex(teamMembers.length);
    } else if (index < teamMembers.length) {
      setIndex(teamMembers.length * 2 - 1);
    }
  };

  const nextSlide = useCallback(() => {
    if (!isCarousel || isTransitioning.current) return;
    isTransitioning.current = true;
    setIndex((prev) => prev + 1);
  }, [isCarousel]);

  const prevSlide = useCallback(() => {
    if (!isCarousel || isTransitioning.current) return;
    isTransitioning.current = true;
    setIndex((prev) => prev - 1);
  }, [isCarousel]);

  const stopAuto = useCallback(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  }, []);

  const startAuto = useCallback(() => {
    stopAuto();
    if (isCarousel) {
      intervalRef.current = setInterval(nextSlide, 2000);
    }
  }, [nextSlide, stopAuto, isCarousel]);

  useEffect(() => {
    startAuto();
    return stopAuto;
  }, [startAuto, stopAuto]);

  return (
    <section className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>Meet Our Team</h2>

        <div
          className={styles.carouselContainer}
          onMouseEnter={isCarousel ? stopAuto : undefined}
          onMouseLeave={isCarousel ? startAuto : undefined}
        >
          {/* Conditionally render arrows */}
          {isCarousel && (
            <>
              <button className={`${styles.navBtn} ${styles.prev}`} onClick={prevSlide}>
                <span>←</span>
              </button>
              <button className={`${styles.navBtn} ${styles.next}`} onClick={nextSlide}>
                <span>→</span>
              </button>
            </>
          )}

          <div className={styles.trackWrapper}>
            <div
              className={styles.track}
              onTransitionEnd={handleTransitionEnd}
              style={
                isCarousel
                  ? {
                    transform: `translateX(-${index * (100 / visibleSlides)}%)`,
                    transition: isTransitioning.current ? "transform 0.7s ease-in-out" : "none"
                  }
                  : {
                    transform: "none",
                    justifyContent: "center",
                    flexWrap: visibleSlides === 1.2 ? "wrap" : "nowrap",
                    gap: visibleSlides === 1.2 ? "20px" : "20px", // Added gap between centered cards
                  }
              }
            >
              {displayMembers.map((member, i) => (
                <div
                  key={i}
                  className={styles.slide}
                  style={{
                    // FIX: Keep width based on visibleSlides (25%) so they don't get giant
                    width: isCarousel
                      ? `${100 / visibleSlides}%`
                      : visibleSlides === 1.2
                        ? "100%"
                        : `${100 / visibleSlides}%`,
                    maxWidth: !isCarousel ? "450px" : "none" // Caps maximum width to prevent excessive height
                  }}
                >
                  <div
                    className={styles.imageBox}
                    style={{
                      // OPTIONAL: If you want the 3 cards to be squarer/shorter than the normal 3/4 ratio
                      aspectRatio: !isCarousel && visibleSlides !== 1.2 ? "1 / 1.35" : "3 / 4"
                    }}
                  >
                    <img src={member.img} alt={member.name} />
                  </div>
                  <div className={styles.info}>
                    <h3>{member.name}</h3>
                    <p>{member.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Conditionally render pagination dots */}
        {isCarousel && (
          <div className={styles.dots}>
            {teamMembers.map((_, i) => (
              <span
                key={i}
                className={(index % teamMembers.length) === i ? styles.activeDot : ""}
                onClick={() => {
                  isTransitioning.current = true;
                  setIndex(teamMembers.length + i);
                }}
              ></span>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default CrewSection;